import { pick } from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';

export class SharedBudgetCampaignSchemaProcessor extends BaseSchemaProcessor {
  constructor(options) {
    super(options);
    this.Permissions = options.globalConfig.get('Permissions');
  }

  // shared budget edit page.
  // keep columns align with the old ui grid.
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = cloneDeep(entitySchema);
    const {
      IsViewThroughConversionsRevenueEnabled,
      IsViewThroughConversionEnabled,
      IsAvgPositionDeprecationPhase2Enabled,
      dynamic = {},
    } = this.Permissions;
    const {
      PartialConversions: IsPartialConversionsEnabled,
      ColumnConversion: IsColumnConversionEnabled,
    } = dynamic;
    const usePartialConversions = IsPartialConversionsEnabled && IsColumnConversionEnabled;

    const propertyList = [
      'Name',
      'PerformanceMetricsClicks',
      'PerformanceMetricsImpressions',
      'PerformanceMetricsCTR',
      'PerformanceMetricsAverageCPC',
      'PerformanceMetricsSpend',
      'PerformanceMetricsAveragePosition',
      usePartialConversions ? 'PerformanceMetricsConversionsCredit' : 'PerformanceMetricsConversions',
      usePartialConversions ? 'PerformanceMetricsPartialConversionRate' : 'PerformanceMetricsConversionRate',
    ];

    if (IsViewThroughConversionEnabled) {
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughConversionsCredit' : 'PerformanceMetricsViewThroughConversions');
    }

    if (IsViewThroughConversionsRevenueEnabled) {
      propertyList.push('PerformanceMetricsViewThroughConversionsRevenue');
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughPartialConversionsCPA' : 'PerformanceMetricsViewThroughConversionsCPA');
      propertyList.push('PerformanceMetricsViewThroughConversionsReturnOnAdSpend');
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughPartialConversionsRate' : 'PerformanceMetricsViewThroughConversionsRate');
    }

    propertyList.push(usePartialConversions ? 'PerformanceMetricsAllConversionsCredit' : 'PerformanceMetricsAllConversions');

    if (IsAvgPositionDeprecationPhase2Enabled) {
      propertyList.push('PerformanceMetricsTopImpressionRate');
      propertyList.push('PerformanceMetricsAbsoluteTopImpressionRate');
    }

    updatedSchema.properties = pick(updatedSchema.properties, propertyList);

    return updatedSchema;
  }
}
